import { normalizeDrill, type Drill } from "../domain/drill";

const KEY = "puckly-coach-drills-v1";

export function loadDrills(
  storage: Pick<Storage, "getItem"> = localStorage,
): Drill[] {
  try {
    const value = storage.getItem(KEY);
    if (!value) return [];
    const parsed: unknown = JSON.parse(value);
    return Array.isArray(parsed) ? (parsed as Drill[]).map(normalizeDrill) : [];
  } catch {
    return [];
  }
}

export function saveDrill(
  drill: Drill,
  storage: Pick<Storage, "getItem" | "setItem"> = localStorage,
): Drill[] {
  const drills = loadDrills(storage);
  const normalized = {
    ...drill,
    title: drill.title.trim() || "Untitled drill",
  };
  const next = [
    normalized,
    ...drills.filter((item) => item.id !== normalized.id),
  ].sort((a, b) => b.updatedAt.localeCompare(a.updatedAt));
  storage.setItem(KEY, JSON.stringify(next));
  return next;
}

export function replaceDrills(
  drills: Drill[],
  storage: Pick<Storage, "setItem"> = localStorage,
): Drill[] {
  const normalized = drills
    .map(normalizeDrill)
    .sort((a, b) => b.updatedAt.localeCompare(a.updatedAt));
  storage.setItem(KEY, JSON.stringify(normalized));
  return normalized;
}

export function deleteDrill(
  id: string,
  storage: Pick<Storage, "getItem" | "setItem"> = localStorage,
): Drill[] {
  const next = loadDrills(storage).filter((drill) => drill.id !== id);
  storage.setItem(KEY, JSON.stringify(next));
  return next;
}
